import { createEnvelopeSource } from './create-envelope-source';

/**
 * RPP engagement source (`GET /analytics/engagement-rpp`): how often registered
 * players come back, off our own auth data.
 *
 * `sessionsPerUserRpp` used to live here too, dividing refresh-token family
 * origins by their distinct players. `login-activity-rpp` computes the same
 * ratio off the login-day table, so it owns the metric now and this source
 * carries the repeat-visit rate alone.
 *
 * Its own source rather than the RPP half of an `engagement` split card, and
 * this is the split that recovered a real figure. The GA4 export behind
 * `engagement` resolves region no finer than a business unit, so the shared
 * envelope declared `businessUnit` grain and the RPP province filter had to be
 * widened to whole business units to keep both halves of a card counting the
 * same geography: a single-province pick answered with the player's whole
 * business unit. Alone, this one declares and serves `province`.
 *
 * Registered players only, and a different basis from the GA4-backed
 * `engagement`: read the rates side by side, never as one number.
 * `avgSessionLengthSeconds` has no RPP twin (refresh tokens carry no duration)
 * and stays on the whole-app source.
 */
export const engagementRppSource = createEnvelopeSource({
    label: 'RPP engagement',
    endpoint: 'analytics/engagement-rpp',
    metrics: [
        {
            id: 'repeatVisitRateRpp',
            label: 'RPP repeat visit rate',
            type: 'ratio',
        },
    ],
    forms: ['rate', 'number'],
    regionGrain: 'province',
});
